import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../hooks/hooks';
import { selectGlobalDbnTaxonomyCategoriesListItems, selectGlobalDbnTaxonomyCategoriesQueryItems } from '../../../../redux/global-dbn-taxonomy-categories/selector';

import { globalDbnTaxonomyCategories } from '../../../../redux/global-dbn-taxonomy-categories/action';
import PageLoader from '../../../../components/PageLoader';
import { globalDbnTaxonomyDomains } from '../../../../redux/global-dbn-taxonomy-domains/action';
import { selectGlobalDbnTaxonomyDomainsListItems } from '../../../../redux/global-dbn-taxonomy-domains/selector';
import { selectCurrent } from '../../../../redux/settings/selectors';
import UploadFiles from '../../../../models/UploadFile';
import { settings } from '../../../../redux/settings/actions';
import { deepCopy } from '../../../../common/services/common.service';
import GlobalDbnTaxonomyCategoriesComponent from '../../global-dbn-taxonomy-categories/components/global-dbn-taxonomy-category.component';
import { selectGlobalDbnServiceCategoriesQueryItems } from '../../../../redux/global-dbn-service-category/selector';
import { GlobalDbnServiceCategoriesComponent } from '../components/global-dbn-service-component';
import { selectGlobalDbnTaxonomySubCategoriesListItems } from '../../../../redux/global-dbn-taxonomy-subcategory/selector';
import { globalDbnTaxonomySubCategoties } from '../../../../redux/global-dbn-taxonomy-subcategory/action';
import { globalDbnServiceCategories } from '../../../../redux/global-dbn-service-category/action';

let currentChange: any = {}

const GlobalDbnServiceCategory = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const queryGlobalDbnServiceCategoryData = useSelector(selectGlobalDbnServiceCategoriesQueryItems)
  const listGlobalDbnTaxonomyCategoryData = useSelector(selectGlobalDbnTaxonomyCategoriesListItems)
  const listGlobalDbnTaxonomyDomainData = useSelector(selectGlobalDbnTaxonomyDomainsListItems)
  const listGlobalDbnSubCategoriesData = useSelector(selectGlobalDbnTaxonomySubCategoriesListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [categoryImageIndex, setCategoryImageIndex] = useState<any>([])
  const [mediaFiles, setMediaFiles] = useState<any>([])
  const [openFile, setOpenFile] = useState<any>([]);
  //       (item: any) =>
  //         item.GlobalDBNCategoryId === subselectedCategory?.GlobalDBNCategoryId
  //     );
  const [subselectedCategory, setSelectedSubCategory] = useState<any[]>([]);
  // console.log(subselectedCategory,"subselectedCategory")
  const [selectedCategory, setSelectedCategory] = useState<any>({
    Code: '',
    IsSubCategory: false,
    Name: '',
    ParentCategoryId: null,
    GlobalDBNCategoryId: 0,
    GlobalDBNDomainId: 0,
    EffectiveDateToUtc: '',
    EffectiveDateFromUtc: ''

  })
  const [entityAttributes, setEntityAttributes] = useState<any>([]);
  const parentCategory = listGlobalDbnTaxonomyCategoryData?.result?.items.filter(
    (subDomainData: any) => subDomainData.IsSubCategory === false
  )
  useEffect(() => {
    if (parmas?.id > 0) {
      fetchGlobalDbnTaxonomyCategoryById();
    }
  }, []);
  const fetchGlobalDbnTaxonomyCategoryById = async () => {
    await dispatch(globalDbnServiceCategories.resetAction({ actionType: 'query' }))
    await dispatch(globalDbnServiceCategories.query({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-service-category-groups/fetch-detail`,
      entity: 'globalDbnServiceCategories',
      jsonData:
      {
        "Context": {
        },
        "Records": [
          {
            "Id": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange = (value: any, field?: string) => {
    if (typeof value === 'object' && !field) {
      setSelectedCategory((prev: any) => ({
        ...prev,
        ...value,
      }));
      return;
    }

    setSelectedCategory((prev: any) => ({
      ...prev,
      [field as string]: value,
    }));
  };
const handleInnerChange = (selectedItems: any, field?: string) => {
  const items = Array.isArray(selectedItems)
    ? selectedItems
    : selectedItems
      ? [selectedItems]
      : [];

  const selectedIds = items
    .map((item: any) =>
      Number(
        item?.value ??
        item?.GlobalDBNCategoryId ??
        item
      )
    )
    .filter((id: number) => id > 0);

  // Find complete data from child category
  const formattedItems = selectedIds
    .map((id: number) => {
      const matchedCategory = (
        listGlobalDbnSubCategoriesData?.result?.items || []
      ).find(
        (item: any) =>
          Number(item?.GlobalDBNCategoryId) === id
      );

      if (!matchedCategory) {
        return null;
      }

      return {
        GlobalDBNCategoryId: Number(
          matchedCategory.GlobalDBNCategoryId
        ),
        Name: matchedCategory.Name || '',
        Code: matchedCategory.Code || '',
      };
    })
    .filter(Boolean);

  console.log("Formatted L3 Categories:", formattedItems);

  // If field is passed, update selectedCategory
  if (field) {
    handleInnerFormChange(
      selectedIds,
      field
    );
  }

  // Always update L3 selected category
  setSelectedSubCategory(formattedItems);
};
  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }


  useEffect(() => {
    // First load domains only
    dispatch(globalDbnTaxonomyDomains.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-domains/dbn-fetch`,
      entity: 'globalDbnTaxonomyDomains',
      jsonData: {
        Context: {},
        Records: [{}],
        Pagination: {
          SortField: "GlobalDBNDomainId",
          SortOrder: "desc",
        }
      }
    }))
  }, []);

  useEffect(() => {
    // First load domains
    dispatch(globalDbnTaxonomyDomains.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-domains/dbn-fetch`,
      entity: 'globalDbnTaxonomyDomains',
      jsonData: {
        Context: {},
        Records: [{}],
        Pagination: {
          SortField: "GlobalDBNDomainId",
          SortOrder: "desc",
        }
      }
    }));
  }, []);


  // CATEGORY DROPDOWN CHANGE → CATEGORY LIST API
  useEffect(() => {
    if (selectedCategory?.GlobalDBNDomainId > 0) {
      dispatch(globalDbnTaxonomyCategories.list({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-categories/dbn-fetch`,
        entity: 'globalDbnTaxonomyCategories',
        jsonData: {
          Context: {},
          Records: [
            {
              GlobalDBNDomainId: selectedCategory?.GlobalDBNDomainId
            }
          ],
          Pagination: {
            PageNumber: 1,
            PageSize: 100,
            SortField: "GlobalDBNDomainId",
            SortOrder: "desc"
          }
        }
      }));
    }
  }, [selectedCategory?.GlobalDBNDomainId]);


  // CATEGORY SELECT → TAKE CATEGORY ID → CALL ANOTHER FETCH API
  useEffect(() => {
    if (selectedCategory?.ParentCategoryId > 0) {
      fetchSubCategoryById(selectedCategory?.ParentCategoryId);
    }
  }, [selectedCategory?.ParentCategoryId]);



  const fetchSubCategoryById = async (categoryId: number) => {


    await dispatch(globalDbnTaxonomySubCategoties.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-categories/dbn-fetch`,
      entity: "globalDbnServiceCategorie",
      jsonData: {
        Context: {},
        Records: [
          {
            "ParentCategoryId": categoryId
          }
        ],
        Pagination: {
          PageNumber: 1,
          PageSize: 100,
          SortField: "GlobalDBNDomainId",
          SortOrder: "desc"
        }
      }
    }));
  };


  useEffect(() => {
    if (isQuery) {
      setSelectedCategory(queryGlobalDbnServiceCategoryData?.result?.items)
      setSelectedSubCategory(queryGlobalDbnServiceCategoryData?.result?.items?.ServiceCategoryGroups)
      const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: queryGlobalDbnServiceCategoryData?.result?.items?.MediaMappings?.MediaFiles || mediaFiles });
      setMediaFiles(localSelectedMedia)

      const selectedEntityAttributes = queryGlobalDbnServiceCategoryData?.result?.items?.EntityAttributes?.map((item: any) => {
        const attributes = {
          EntityAttributeName: item?.EntityAttributeName,
          EntityAttributeTypeId: item?.EntityAttributeTypeId,
          ValueItem1Type:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem1?.Type || '',
          ValueItem1Value:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem1?.Value || '',
          ValueItem1IsSelected:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem1
              ?.IsSelected || false,
          ValueItem2Type:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem2?.Type || '',
          ValueItem2Value:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem2?.Value || '',
          ValueItem2IsSelected:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem2
              ?.IsSelected || false,
          ValueItem3Type:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem3?.Type || '',
          ValueItem3Value:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem3?.Value || '',
          ValueItem3IsSelected:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem3
              ?.IsSelected || false,
          ValueItem4Type:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem4?.Type || '',
          ValueItem4Value:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem4?.Value || '',
          ValueItem4IsSelected:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem4
              ?.IsSelected || false,
          ValueItem5Type:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem5?.Type || '',
          ValueItem5Value:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem5?.Value || '',
          ValueItem5IsSelected:
            item?.EntityAttributeValue?.MultiControlType?.ValueItem5
              ?.IsSelected || false,
          TextValue:
            item?.EntityAttributeValue?.SingleControlType?.TextValue || '',
          NumberValue:
            item?.EntityAttributeValue?.SingleControlType?.NumberValue || 0,
          DateValue:
            item?.EntityAttributeValue?.SingleControlType?.DateValue || '',
          FileTypeId:
            item?.EntityAttributeValue?.SingleControlType?.FileTypeId || 0,
          FileMappingUrl:
            item?.EntityAttributeValue?.SingleControlType?.FileMappingUrl || '',
          OwnerTypeId: item?.OwnerTypeId || 0,
          OwnerId: item?.OwnerId || 0,
        };
        return attributes;
      });
      setEntityAttributes(selectedEntityAttributes);
    }
  }, [isQuery])

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    mediaFiles.splice(
      mediaFiles.length - 1,
      1
    )

    const localMediaFiles = _.map(mediaFiles, (item) => {
      return {
        ...item,
        OwnerId: Number(parmas?.id) || 0,
        Name: selectedCategory?.Name,
        Description: selectedCategory?.Name,
        IsApproved: true,
      }
    })

    if (parmas?.id > 0) {

      entityAttributes?.splice(entityAttributes.length - 1, 1);
      const selectedEntityAttributes: any = entityAttributes?.map((item: any) => {
        const attributes: any = {
          Id: item?.Id,
          EntityAttributeName: item?.EntityAttributeName,
          EntityAttributeTypeId: item?.EntityAttributeTypeId,
          EntityAttributeValue: {
            MultiControlType: {
              ValueItem1: {
                Type: item?.ValueItem1Type || 'string',
                Value: item?.ValueItem1Value || 'string',
                IsSelected: item?.ValueItem1IsSelected || false,
              },
              ValueItem2: {
                Type: item?.ValueItem2Type || 'string',
                Value: item?.ValueItem2Value || 'string',
                IsSelected: item?.ValueItem2IsSelected || false,
              },
              ValueItem3: {
                Type: item?.ValueItem3Type || 'string',
                Value: item?.ValueItem2Value || 'string',
                IsSelected: item?.ValueItem3IsSelected || false,
              },
              ValueItem4: {
                Type: item?.ValueItem4Type || 'string',
                Value: item?.ValueItem4Value || 'string',
                IsSelected: item?.ValueItem4IsSelected || false,
              },
              ValueItem5: {
                Type: item?.ValueItem5Type || 'string',
                Value: item?.ValueItem5Value || 'string',
                IsSelected: item?.ValueItem5IsSelected || false,
              },
            },
            SingleControlType: {
              TextValue: item?.TextValue || 'string',
              NumberValue: item?.NumberValue || 0,
              DateValue: item?.DateValue || '2024-05-22T04:52:47.083',
              FileTypeId: item?.FileTypeId || 0,
              FileMappingUrl: item?.FileMappingUrl || 'string',
            },
          },
          OwnerTypeId: item?.OwnerTypeId || 0,
          OwnerId: Number(parmas?.id) || 0,
        };
        return attributes;
      });

      const categoryData = {
        "Id": selectedCategory?.GlobalDBNServiceCategoryGroupId,
        "GlobalDBNDomainId": selectedCategory?.GlobalDBNDomainId,
        "GlobalDBNCategoryId": selectedCategory?.GlobalDBNCategoryId,
        "Name": selectedCategory?.Name,
        "Code": selectedCategory?.Code,
        ServiceCategoryGroups: (subselectedCategory || []).map((item: any) => ({
          GlobalDBNCategoryId: Number(item?.GlobalDBNCategoryId) || 0,
          Name: item?.Name || '',
          Code: item?.Code || '',
        })),
        "EffectiveDateFromUtc": selectedCategory?.CreatedOnUtc,
        "EffectiveDateToUtc": selectedCategory?.ModifiedOnUtc
      }
      await dispatch(globalDbnServiceCategories.resetAction({ actionType: 'update' }))
      await dispatch(globalDbnServiceCategories.update({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-service-category-groups
`,
        entity: 'globalDbnServiceCategories',
        jsonData: {
          Context: {},
          Records: [
            categoryData
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      const categoryData = {
        "Id": 0,
        "GlobalDBNDomainId": selectedCategory?.GlobalDBNDomainId,
        "GlobalDBNCategoryId": selectedCategory?.GlobalDBNCategoryId,
        "Name": selectedCategory?.Name,
        "Code": selectedCategory?.Code,
        ServiceCategoryGroups: (subselectedCategory || []).map((item: any) => ({
          GlobalDBNCategoryId: Number(item?.GlobalDBNCategoryId) || 0,
          Name: item?.Name || '',
          Code: item?.Code || '',
        })),
        "EffectiveDateFromUtc": selectedCategory?.CreatedOnUtc,
        "EffectiveDateToUtc": selectedCategory?.ModifiedOnUtc
      }
      await dispatch(globalDbnServiceCategories.resetAction({ actionType: 'create' }))
      await dispatch(globalDbnServiceCategories.create({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-service-category-groups`,
        entity: 'globalDbnServiceCategories',
        jsonData: {
          Context: {},
          Records: [
            categoryData
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/dbn/service-category')
  }

  const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
      Id: 0,
      FileTypeId: 0,
      OwnerTypeId: 175,
      FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }
    return localSelectedmedia
  }

  const setCombinationInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }

  const changeImage = (idx: number, templateField: any, fileType: any) => {
    setCategoryImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: mediaFiles[idx][templateField],
      folder: 'Category',
      type: fileType
    })
  }


  const handleSubmit = (data: any) => {
    mediaFiles[categoryImageIndex].FileMappingURL = data
    const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    setMediaFiles(localSelectedMedia)
  }

  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))
  }

  useEffect(() => {
    if (currentChange.field === 'FileTypeId') {
      setCombinationInfo()
    }
  }, [mediaFiles]
  )

  return (
    <>
      {getUploadFiles == 'open' && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
        folder={openFile?.folder}
        handleClose={handleClose}
        handleFilesSubmit={handleSubmit}
        type={openFile?.type}
        ownerId={parmas?.id}
      />}
      {listGlobalDbnTaxonomyDomainData?.isLoading ||
        listGlobalDbnTaxonomyCategoryData?.isLoading ||
        queryGlobalDbnServiceCategoryData?.isLoading ? <PageLoader /> :
        <GlobalDbnServiceCategoriesComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedCategory={selectedCategory}
          subselectedCategory={subselectedCategory}
          handleInnerChange={handleInnerChange}
          parentCategory={parentCategory}
          childCategory={listGlobalDbnSubCategoriesData?.result?.items}
          back={back}
          handleFormSubmit={handleFormSubmit}
          entityAttributes={entityAttributes}
          setEntityAttributes={setEntityAttributes}
          id={parmas?.id}
          domains={listGlobalDbnTaxonomyDomainData?.result?.items}
          handleFormItemChange={handleFormItemChange}
          mediaFiles={mediaFiles}
          changeImage={changeImage}
        //  functionAttributes={functionAttributes}
        //  setFunctionAttributes={setFunctionAttributes}
        />
      }
    </>
  )
}

export default GlobalDbnServiceCategory;
